import Tooltip, { Header, Message } from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode } from 'react';

type Props = {
    darkGrey?: boolean;
    info: ReactNode;
    popoverContent: ReactNode;
    price?: ReactNode;
    title: ReactNode;
};

export const ShippingMethodLabel = ({ darkGrey, info, popoverContent, price, title }: Props) => {
    return (
        <div className="w-full grid-rows-[3fr_1fr] gap-sm">
            <div className="flex w-full justify-between">
                <div className="flex items-center">
                    <LabelStrong color={darkGrey ? 'secondary' : 'primary'}>{title}</LabelStrong>
                    <Tooltip
                        trigger={
                            <Info
                                className="-mb-2xs ml-2xs"
                                color="primary"
                                size="xs"
                                style="fill"
                            />
                        }
                    >
                        <Header>
                            <FormattedMessage id="checkout.shippingMethod.popovers.title" />
                        </Header>
                        <Message last>{popoverContent}</Message>
                    </Tooltip>
                </div>
                <LabelStrong>{price}</LabelStrong>
            </div>
            <BodySecondary color="secondary">{info}</BodySecondary>
        </div>
    );
};
